export default __webpack_public_path__ + "images/searchglas_809ba680c896c0ca320b3b3f9913058d.svg";